<template>
  <div class="container">
    <div class="menu">
      <div class="submenu">
        <!-- <ith-submenu-imdb /> -->
        <ith-submenu-genres />
        <ith-submenu-languages />
        <ith-submenu-months />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.menu {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  justify-content: stretch;
  column-gap: 15px;
  border-bottom: 1px solid #738092;
  align-items: center;
}
.submenu {
  display: grid;
  grid-template-columns: repeat(3, auto);
  justify-content: start;
  column-gap: 35px;
  position: relative;
  padding: 5px 10px;
}

.menu--item-select {
  align-self: end;
  column-gap: 50px;
}
.select-sort {
  color: white;
  border: 1px solid #738092;
  border-radius: 10px;
  margin-top: 0px;
  margin-bottom: -1px;
  margin-left: 50px;
  padding: 5px 10px 5px 10px;
  font-size: 14px;
  background: none;
}
.router-link-active {
  font-weight: 600;
  padding: 0px 10px 5px 10px;
  border-bottom: 3px solid white;
}

@media (min-width: 1400px) {
  .menu {
    grid-template-columns: 70% 30%;
    column-gap: 0%;
    justify-content: space-between;
    padding-top: 10px;
  }
  .submenu {
    grid-template-columns: repeat(3, auto);
    column-gap: 2%;
  }
  .menu--item-select {
    justify-self: end;
    margin-right: -5px;
  }
}
@media (min-width: 1264px) and (max-width: 1400px) {
  .menu {
    column-gap: 0%;
    justify-content: space-between;
    padding-top: 10px;
  }
  .submenu {
    grid-template-columns: repeat(3, auto);
    column-gap: 2%;
  }
  .menu--item-select {
    justify-self: end;
    margin-right: -5px;
  }
}
@media (min-width: 960px) and (max-width: 1264px) {
  .menu {
    margin-left: 2%;
    grid-template-columns: 70% 30%;
    column-gap: 0%;
    justify-content: space-between;
    padding-top: 10px;
  }
  .submenu {
    grid-template-columns: repeat(3, auto);
    column-gap: 2%;
  }
  .menu--item-select {
    justify-self: end;
    margin-right: 20px;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .menu {
    margin-left: 3%;
    grid-template-columns: 70% 30%;
    column-gap: 0%;
    justify-content: space-between;
    padding-top: 10px;
  }
  .submenu {
    grid-template-columns: repeat(3, auto);
    column-gap: 2%;
  }
  .menu--item-select {
    justify-self: end;
    margin-right: 20px;
  }
}

@media (max-width: 600px) {
  .menu {
    column-gap: 0%;
    justify-content: space-between;
    padding-top: 10px;
    align-items: center;
  }
  .submenu {
    grid-template-columns: repeat(3, auto);
    column-gap: 2%;
  }
  .menu--item-select {
    justify-self: end;
    margin-right: 20px;
    padding: 2px 7px;
  }
  .select-sort {
    font-size: 8px;
    border-radius: 6px;
    margin-right: -30px;

    margin-bottom: -3px;
  }
}
</style>
